import { useState, useEffect } from 'react';
import { getUserBadges } from '../badgeService';
// import { formatRelativeTime } from '../utils/timeUtils';

/**
 * UserBadges - Displays achievement badges for users
 *
 * Displays badges like "Top 1% Commenter" that are awarded to users
 * by admins through database edits.
 *
 * STYLING STANDARDS:
 * - Compact variant (smaller than OrgVerificationBadge):
 *   px-1.5 py-0.5, border (400-shade), rounded-full, text-[11px], icon text-xs, gap-1
 * - Default variant: px-3 py-2, border, rounded-lg, text-sm, icon text-xl
 * - Only color scheme varies per badge type (background, border, text colors)
 *
 * RESPONSIVE BEHAVIOR:
 * - Badge labels truncate on mobile (max-w-[100px]), full width on desktop
 * - Tooltips left-aligned on mobile, center-aligned on desktop (prevents overflow)
 * - Badge container wraps on narrow screens (flex-wrap)
 */
const UserBadges = ({ address, className = '', variant = 'compact', chain = null }) => {
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [hoveredBadge, setHoveredBadge] = useState(null);

  useEffect(() => {
    const loadBadges = async () => {
      if (!address) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await getUserBadges(address, chain || 'ethereum');
        setBadges(data);
      } catch (error) {
        console.error('Error loading badges:', error);
        setBadges([]);
      } finally {
        setLoading(false);
      }
    };

    loadBadges();
  }, [address, chain]);

  // Don't render anything if loading, no address, or no badges
  if (loading || !address || badges.length === 0) {
    return null;
  }

  // Compact variant - small badges with tooltips
  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-center gap-1.0 flex-wrap ${className}`}>
        {badges.map((badge, index) => (
          <div
            key={index}
            className={`relative inline-flex items-center gap-1.5 px-1.5 py-0.5 bg-gradient-to-r ${badge.color} border ${badge.borderColor} rounded-full text-xs whitespace-nowrap`}
            // onMouseEnter={() => setHoveredBadge(index)}
            // onMouseLeave={() => setHoveredBadge(null)}
          >
            {/* Badge Icon */}
            <span className="text-xs flex-shrink-0">{badge.icon}</span>

            {/* Badge Label - truncate on narrow screens */}
            <span className={`font-medium ${badge.textColor} max-w-[120px] sm:max-w-none text-[12px]`}>
              {badge.label}
            </span>

            {/* Tooltip - responsive positioning to prevent overflow */}
            {/* {hoveredBadge === index && (
              <div
                className="absolute z-50 pt-2 top-full left-0 sm:left-1/2 sm:-translate-x-1/2"
                onMouseEnter={() => setHoveredBadge(index)}
                onMouseLeave={() => setHoveredBadge(null)}
              >
                <div className="p-3 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden" style={{width: 'min(280px, 90vw)', maxWidth: '280px'}}>
                  <div className="text-xs space-y-2">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xl flex-shrink-0">{badge.icon}</span>
                      <div className="font-semibold text-gray-700 break-words" style={{overflowWrap: 'anywhere'}}>{badge.label}</div>
                    </div>
                    {badge.description && (
                      <div className="text-gray-600 whitespace-normal break-words leading-relaxed" style={{overflowWrap: 'anywhere'}}>{badge.description}</div>
                    )}
                    {badge.awardedAt && (
                      <div>
                        <div className="font-semibold text-gray-700">Awarded</div>
                        <div className="text-gray-600 break-words" style={{overflowWrap: 'anywhere'}}>{formatRelativeTime(badge.awardedAt)}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )} */}
          </div>
        ))}
      </div>
    );
  }

  // // Default variant - larger badges for display pages
  // return (
  //   <div className={`flex flex-wrap gap-2 ${className}`}>
  //     {badges.map((badge, index) => (
  //       <div
  //         key={index}
  //         className={`flex items-center gap-2 px-3 py-2 bg-gradient-to-r ${badge.color} border ${badge.borderColor} rounded-lg`}
  //       >
  //         <span className="text-xl">{badge.icon}</span>
  //         <div className="flex flex-col">
  //           <span className={`font-semibold text-sm ${badge.textColor}`}>
  //             {badge.label}
  //           </span>
  //           {badge.description && (
  //             <span className="text-xs text-gray-600">{badge.description}</span>
  //           )}
  //         </div>
  //       </div>
  //     ))}
  //   </div>
  // );
};

export default UserBadges;
